import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MyModal } from "../../../global/MyModal";
import { SolidButton } from "../../../global/SolidButton";
import { Plus } from "lucide-react";
import Pagination from "../../../util/Pagination";
import { BorderButton } from "../../../global/BorderButton";
import GameCard from "../../../tools/GameCard";
import { MyGamePreview } from "../../../global/MyGamePreview";
import { addGame, getGames, removeGame, updateGame } from "../api";
import toast from "react-hot-toast";
import MyLoader from "../../../util/MyLoader";

export default function GameManage() {
  const [activeTab, setActiveTab] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
 // const [search, setSearch] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [isPreviewOpen, setPreviewOpen] = useState(false);

  const [name, setName] = useState();
  const [genre, setGenre] = useState();
  const [gameUrl, setGameUrl] = useState(null);
  const [iconUrl, setIconUrl] = useState(null);
  const [bannerUrl, setBannerUrl] = useState(null);
  const [des, setDes] = useState("");
  const [coins, setCoins] = useState(0);
  const [rank, setRank] = useState(1);

  const [errors, setErrors] = useState({});
  const [isDisabled, setDisabled] = useState(false);
  const [currentGameId, setCurrentGameId] = useState(null);

  // pagination states
 // const [page, setPage] = useState(1);
 // const [limit, setLimit] = useState(10);
 // const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [games, setGames] = useState([]);
  const [gameLink, setGameLink] = useState("");

  const type = [
    //  { id: 1, label: "All Bonus" },
    { id: 0, label: "All", value: "all" },
    { id: 1, label: "Active", value: "active" },
    { id: 2, label: "Inactive", value: "inactive" },
  ];

  const { id } = useParams();
  const navigate = useNavigate();

  const fetchGames = async () => {
    try {
      const res = await getGames();
      if (res?.status === 200) {
        const data = res?.data?.data;
        setGames(data);
        clearAllField();
      }
    } catch (err) {
      console.error("Failed to fetch games", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchGames();
  }, []);

  useEffect(() => {
    if (games.length > 0) {
      setRank(games.length + 1);
    }
  }, [games]);

  const handleDelete = async () => {
    try {
      const res = await removeGame(deleteId);
      if (res.status === 200) {
        toast.success("Game deleted successfully");
        // refresh list
        fetchGames();
      }
    } catch (err) {
      console.error("Failed to delete game", err);
      toast.error(err.response?.data?.error || "Failed to delete game");
    }
    setDeleteId(null);
  };

  const handleTabClick = (tabId) => {
    const selectedTab = type.find((item) => item.id === tabId);

    if (!selectedTab) return;

    navigate(`/apps/${id}/settings/bonus?status=${selectedTab.value}`);
    setActiveTab(tabId);
  };
  const copyGameUrl = async (gameUrl) => {
    try {
      await navigator.clipboard.writeText(gameUrl); // or data.url
      toast.success("Game URL copied!");
    } catch (err) {
      console.error(err);
      toast.error("Failed to copy URL");
    }
  };
  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!validateForm()) return;
    const payload = {
      title: name.trim(),
      genre: genre.trim(),
      description: des?.trim(),
      icon: iconUrl?.trim(),
      banner: bannerUrl?.trim(),
      coins: Number(coins),
      gameUrl: gameUrl?.trim(),
      rank: Number(rank),
      status: true,
    };
    try {
      const res = isEditMode
        ? await updateGame(currentGameId, payload)
        : await addGame(payload);
      if (res?.status === 200) {
        fetchGames();
        setIsModalOpen(false);

        toast.success(
          isEditMode ? "succcessfully updated" : "successfully added",
        );
      }
    } catch (err) {
      console.error("Failed to submit data", err);
    }
  };
  const changeStatus=async(id,status)=>{
    try{
      const payload = {
      status: status,
    };
      const res= await updateGame(id,payload);
      if(res?.status===200){
        toast.success(status?"active":"inactive");
        
      }
    }catch(err){
       console.error("Failed to change status", err);
    }
  }
  const editGame = (data) => {
    setIsEditMode(true);
    setIsModalOpen(true);
    setName(data.title);
    setGenre(data.genre);
    setDes(data.description);
    setIconUrl(data.icon);
    setBannerUrl(data.banner);
    setCoins(data.coins);
    setGameUrl(data.gameUrl);
    setRank(data.rank);
    setCurrentGameId(data.id);
  };

  const clearAllField = () => {
    setName(null);
    setGenre(null);
    setDes(null);
    setIconUrl(null);
    setBannerUrl(null);
    setGameUrl(null);
    setCoins(0);
    setRank(0);
    setCurrentGameId(null);
    setIsEditMode(false);
  };

  const validateForm = () => {
    const errs = {};
    //name
    if (!name || !name.trim()) {
      errs.name = "Name is required";
    }
    //genre
    if (!genre || !genre.trim()) {
      errs.genre = "Genre is required";
    }
    //description
    if (!des || !des.trim()) {
      errs.des = "Description is required";
    }
    //icon url
    if (!iconUrl || !iconUrl.trim()) {
      errs.iconUrl = "game icon is required";
    }
    if (!bannerUrl || !bannerUrl.trim()) {
      errs.bannerUrl = "game banner is required";
    }
    //  if (!iconUrl?.trim.startWith("https://")) {
    //   errs.iconUrl = "invalid HTTPS URL";
    // }
    //Game url
    if (!gameUrl || !gameUrl.trim()) {
      errs.gameUrl = "Game URL is required";
    }
    //coin  validation
    if (coins <= 0 || isNaN(Number(coins))) {
      errs.coins = "Coin must be greater than zero";
    }
    // //bonus title validation
    // if (!title || !title.trim()) {
    //   errs.bonusTitle = "Bonus Title is required";
    // }
    // //transaction message validation
    // if (!transMessage || !transMessage.trim()) {
    //   errs.transMessage = "Transaction Message is required";
    // }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  if (loading) return <MyLoader />;

  return (
    <Fragment>
      <div className="space-y-2 h-screen relative  ">
        <div className="flex flex-row items-center justify-start space-x-4">
          {/* tabs */}
          <div
            className=" py-2 p-2 bg-slate-300/25 dark:bg-gray-700/30 backdrop-blur-xl rounded-lg   
              "
          >
            {type.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab.id)}
                className={` text-xs border 
                 mr-2
           p-1 rounded-sm transition-all duration-200 transform
           text-slate-800 dark:text-slate-300 font-normal ${
             tab.id === activeTab
               ? "bg-white dark:bg-slate-100/2 border dark:via-slate-800 dark:to-slate-900 border-slate-300"
               : "border-transparent cursor-pointer"
           }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* search */}
          <div>
            <input
              type="text"
              placeholder="Search bonus"
              //   value={search}
              //  onChange={(e) => setSearch(e.target.value)}
              className="w-[250px]  text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
            />
          </div>
          {/* Button */}
          <div className="ml-auto">
            <SolidButton
              onClick={() => setIsModalOpen(true)}
              children={
                <>
                  <Plus className="w-4 h-4" />
                  <span>Add Game</span>
                </>
              }
            />
          </div>
        </div>
        {/* games listing */}
        <div className="grid grid-cols-1 xl:grid-cols-3 sm:grid-cols-2 gap-4 mt-5">
          {games.map((data, index) => (
            <div key={index}>
              <GameCard
                data={data}
                onPreview={() => {
                  console.log("onPreview");
                  setGameLink(data.gameUrl);
                  setPreviewOpen(true);
                }}
                onDelete={() => {
                  setDeleteId(data.id);
                }}
                onEdit={() => {
                  editGame(data);
                }}
                onCopy={() => {copyGameUrl(data.gameUrl);}}
                onUpdate={(status)=>{
                  changeStatus(data.id,status)
                }}
              />
            </div>
          ))}

          {/* <GameCard />
          <GameCard /> */}
        </div>
      </div>
      {/* ADD / EDIT MODAL */}

      <MyModal
        isOpen={isModalOpen}
        title={isEditMode ? "Update Game" : "Add New Game"}
        onClose={() => {
          setIsModalOpen(false);
          clearAllField();
        }}
        width="560px"
      >
        <div className="w-full space-y-4 mt-4">
          {/* Name and genre */}
          <div className="flex  items-start justify-between space-x-6   w-full">
            {/* Name */}
            <div className="flex flex-col  md:w-1/1">
              <label className="block text-xs font-medium text-slate-500 mb-1">
                Name*
              </label>
              <input
                type="text"
                placeholder="e.g.,Fleppy Bird"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  if (errors.name)
                    setErrors((prev) => ({ ...prev, coinAmount: undefined }));
                }}
                aria-invalid={!!errors.name}
                className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                  errors.name
                    ? "border-red-400"
                    : "border-slate-200 dark:border-slate-700"
                }`}
              />
              {errors.name && (
                <div className="text-xs text-red-500 mt-1">{errors.name}</div>
              )}
              <p className="text-[10px] text-gray-500 dark:text-slate-400 font-semibold mt-1">
                Game title should be less then 20 chars
              </p>
            </div>
            {/* Genre */}
            <div className="flex flex-col  md:w-1/2">
              <label className="block text-xs font-medium text-slate-500 mb-1">
                Genre*
              </label>
              <input
                type="text"
                placeholder="e.g.,Adventure,Racing"
                name="genre"
                value={genre}
                min={1}
                onChange={(e) => {
                  setGenre(e.target.value);
                }}
                aria-invalid={!!errors.genre}
                className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                  errors.genre
                    ? "border-red-400"
                    : "border-slate-200 dark:border-slate-700"
                }`}
              />
              {errors.genre && (
                <div className="text-xs text-red-500 mt-1">{errors.genre}</div>
              )}
            </div>
          </div>
          {/* Description */}
          <div className="mt-4">
            <label className="block text-xs font-medium text-slate-500 mb-1">
              Description*
            </label>
            <textarea
              type="text"
              name="des"
              placeholder="e.g.,Battle Royale game with exciting gamepla"
              value={des}
              onChange={(e) => {
                setDes(e.target.value);
                if (errors.transMessage)
                  setErrors((prev) => ({ ...prev, transMessage: undefined }));
              }}
              aria-invalid={!!errors.des}
              className={`w-full h-20 text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                errors.des
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />
            {errors.des && (
              <div className="text-xs text-red-500 mt-1">{errors.des}</div>
            )}
          </div>
          {/* Game Icon */}
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">
              Icon*
            </label>
            <input
              type="url"
              name="iconUrl"
              placeholder="e.g.,https://media.adwave.in/icons/game/fleppy.jpg"
              value={iconUrl}
              onChange={(e) => {
                setIconUrl(e.target.value);
                if (errors.iconUrl)
                  setErrors((prev) => ({ ...prev, title: undefined }));
              }}
              aria-invalid={!!errors.iconUrl}
              className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                errors.iconUrl
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />

            {errors.iconUrl && (
              <div className="text-xs text-red-500 mt-1">{errors.iconUrl}</div>
            )}
            <p className="text-[10px] text-gray-500 dark:text-slate-400 font-semibold mt-1">
              url should be with http or https
            </p>
          </div>
          {/* Game Banner */}
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">
              Banner*
            </label>
            <input
              type="url"
              name="bannerUrl"
              placeholder="e.g.,https://media.adwave.in/icons/game/fleppy.jpg"
              value={bannerUrl}
              onChange={(e) => {
                setBannerUrl(e.target.value);
                if (errors.bannerUrl)
                  setErrors((prev) => ({ ...prev, bannerUrl: undefined }));
              }}
              aria-invalid={!!errors.bannerUrl}
              className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                errors.bannerUrl
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />

            {errors.bannerUrl && (
              <div className="text-xs text-red-500 mt-1">
                {errors.bannerUrl}
              </div>
            )}
            <p className="text-[10px] text-gray-500 dark:text-slate-400 font-semibold mt-1">
              url should be with http or https
            </p>
          </div>
          {/* Game Url */}
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">
              Game URL*
            </label>
            <input
              type="url"
              name="gameUrl"
              placeholder="e.g.,https://games.adwave.in/walls"
              value={gameUrl}
              onChange={(e) => {
                setGameUrl(e.target.value);
                if (errors.gameUrl)
                  setErrors((prev) => ({ ...prev, title: undefined }));
              }}
              aria-invalid={!!errors.gameUrl}
              className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                errors.gameUrl
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />

            {errors.gameUrl && (
              <div className="text-xs text-red-500 mt-1">{errors.gameUrl}</div>
            )}
            <p className="text-[10px] text-gray-500 dark:text-slate-400 font-semibold mt-1">
              url should be with http or https
            </p>
          </div>

          {/* coins and rank */}
          <div className="grid grid-cols-2  items-center justify-center gap-4   w-full">
            {/* coin amount */}
            <div className="flex flex-col ">
              <label className="block text-xs font-medium text-slate-500 mb-1">
                Coins*
              </label>
              <input
                type="number"
                placeholder="e.g.,100,500,1000"
                value={coins}
                onChange={(e) => {
                  setCoins(e.target.value);
                  if (errors.coins)
                    setErrors((prev) => ({ ...prev, coinAmount: undefined }));
                }}
                aria-invalid={!!errors.coins}
                className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                  errors.coins
                    ? "border-red-400"
                    : "border-slate-200 dark:border-slate-700"
                }`}
              />
              {errors.coins && (
                <div className="text-xs text-red-500 mt-1">{errors.coins}</div>
              )}
              <p className="text-[10px] text-gray-500 dark:text-slate-400 font-semibold mt-1">
                this is winning coins from playing games
              </p>
            </div>
            {/* Rank*/}
            <div className="flex flex-col ">
              <label className="block text-xs font-medium text-slate-500 mb-1">
                Rank*
              </label>
              <select
                type="number"
                name="rank"
                value={rank}
                defaultValue={rank + 1}
                min={1}
                onChange={(e) => {
                  setRank(e.target.value);
                }}
                aria-invalid={!!errors.rank}
                className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                  errors.rank
                    ? "border-red-400"
                    : "border-slate-200 dark:border-slate-700"
                }`}
              >
                {games.map((data) => (
                  <option value={data.rank + 1}>{data.rank + 1}</option>
                ))}
              </select>
              <p className="text-[10px] text-gray-500 dark:text-slate-400 font-semibold mt-1">
                game can be set in order by rank
              </p>
            </div>
          </div>

          <div className="bg-slate-300 dark:bg-slate-700 h-[1px] mt-4" />

          {/* action buttons */}
          <div className="flex space-x-4 justify-end mt-6">
            <BorderButton
              onClick={() => {
                setIsModalOpen(false);
                clearAllField();
              }}
            >
              <span className="text-sm text-slate-400">Cancel</span>
            </BorderButton>
            <SolidButton
              disabled={isDisabled}
              className="px-4 py-2 text-sm space-x-2"
              onClick={(e) => handleSubmit(e)}
            >
              {isEditMode ? "Update Game" : "Create Game"}
            </SolidButton>
          </div>
        </div>
      </MyModal>
      {/* DELETE CONFIRM MODAL */}
      <MyModal
        isOpen={!!deleteId}
        title="Delete Game?"
        onClose={() => setDeleteId(null)}
      >
        <p className="text-sm text-slate-800 dark:text-slate-300 mt-4">
          Are you sure you want to delete this Game?
        </p>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={() => setDeleteId(null)}
            className="px-4 py-2 rounded-lg bg-slate-400/20 dark:bg-slate-800 text-sm"
          >
            Cancel
          </button>

          <SolidButton onClick={handleDelete} children={<span>Delete</span>} />
        </div>
      </MyModal>
      {/* Game Preview */}
      <MyGamePreview
        isOpen={isPreviewOpen}
        onClose={() => setPreviewOpen(false)}
        gameUrl={gameLink}
      />
    </Fragment>
  );
}

function formatDateTime(dateString) {
  if (!dateString) return "-";

  const date = new Date(dateString);

  // ✅ prevent RangeError
  if (isNaN(date.getTime())) return "-";

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date);
}
